import {
  getString,
} from "@surya-digital/leo-ts-types";

export interface HexCodeDTO {
  code: string;
}

export class HexCode {
  readonly isHexCodeHexCode: boolean = true;

  readonly code: string;

  static readonly constraints = {
    "code": {
      "minSize": 7,
      "maxSize": 7,
      
      
      
      
    }
  }

  constructor(
  code: string
  ) {
    HexCode.validateCode(code);
    this.code = code;
  }

  static fromDTO(dto: HexCodeDTO): HexCode {
    const code = getString(dto, "code", InvalidHexCodeCodeError);
    return new HexCode(
      code
    );
  }

  toDTO(): HexCodeDTO {
    const dto: HexCodeDTO = {
        code: this.code
    };
    return dto;
  }
  private static validateCode = (code: string): void => {
    if(code.length < 7) {
      throw new InvalidHexCodeCodeMinSizeError(
        7,
        `Attribute code is too short. Size is ${code.length}. Min size is 7.`
      );
    }
    if(code.length > 7) {
      throw new InvalidHexCodeCodeMaxSizeError(
        7,
        `Attribute code is too long. Size is ${code.length}. Max size is 7.`
      );
    }
      if(code.trim().length === 0) {
        throw new InvalidHexCodeCodeNonEmptyError(
          `Attribute code cannot be an empty string.`
        );
      }
  }
  
}

HexCode.prototype.toString = function toString(): string {
  return `HexCode(code='${this.code}')`;
};

export class InvalidHexCodeError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidHexCodeError";
  }
}
export class InvalidHexCodeCodeError extends InvalidHexCodeError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidHexCodeCodeError";
  }
}

export class InvalidHexCodeCodeMaxSizeError extends InvalidHexCodeCodeError {
  readonly maxSize: number;
  constructor(maxSize: number, message?: string) {
    super(message);
    this.maxSize = maxSize;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidHexCodeCodeMaxSizeError";
  }
}

export class InvalidHexCodeCodeMinSizeError extends InvalidHexCodeCodeError {
  readonly minSize: number;
  constructor(minSize: number, message?: string) {
    super(message);
    this.minSize = minSize;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidHexCodeCodeMinSizeError";
  }
}

export class InvalidHexCodeCodeNonEmptyError extends InvalidHexCodeCodeError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidHexCodeCodeNonEmptyError";
  }
}
